import React from 'react'
import Headers from '../../../components/Headers'
import { Input, Upload, Icon, Modal, message, Carousel } from 'antd'
import NProgress from 'nprogress'
import MobilePhone1 from '../../../assets/images/mobilePhone1.png'
import FuncIconSet from './function_icon_set'
import './index.scss'
import {
  fetchSmallProgramSet,
  fetchSetSmallProgram,
} from '../../../api/smallProgramSet'
import { upload_token } from '../../../utils/token'
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}

const BreadCrumbData = [
  { path: '/page/ssry/userInfo', name: '试试如意' },
  { path: '/page/ssry/smallProgramSet', name: '小程序自定义' },
]

class SmallProgramSet extends React.Component {
  state = {
    info: {
      banner: [],
    },
    token: upload_token(),
    previewVisible: false,
    previewImage: '',
    fileList: [],
    linkList: [],
  }
  getInfo = (state) => {
    fetchSmallProgramSet().then((res) => {
      if (res.success) {
        let banner = []
        let fileList = []
        let linkList = []
        res.data.banner = res.data.banner.split(';')
        if (res.data.banner.length > 1) {
          res.data.banner.forEach((item, index) => {
            if (item) {
              banner.push(item)
              linkList.push({ url: '', temp_url: '' })
              fileList.push({
                url: item,
                response: { key: item },
                uid: index,
                status: 'done',
              })
            }
          })
          this.setState({
            info: { ...res.data, banner, setOld: false, setNew: false },
            fileList: state ? fileList : this.state.fileList,
            linkList,
          })
        } else {
          banner = JSON.parse(res.data.banner)
          let arr = []
          banner.forEach((item, index) => {
            if (item) {
              arr.push(item.img)
              linkList.push({ url: item.link, temp_url: item.link })
              fileList.push({
                url: item.img,
                response: { key: item.img },
                uid: index,
                status: 'done',
              })
            }
          })
          this.setState({
            info: { ...res.data, banner: arr, setOld: false, setNew: false },
            fileList: state ? fileList : this.state.fileList,
            linkList,
          })
        }
      }
    })
  }
  componentDidMount() {
    NProgress.start()
    this.getInfo(true)
    NProgress.done()
  }
  handleCancel = () => this.setState({ previewVisible: false })

  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    })
  }
  handleRemove = (e) => {
    if (this.state.fileList.length === 1) {
      message.error('至少保留一张图片')
      return false
    }
  }
  handleChange = ({ fileList, file }) => {
    let banner = []
    let linkList = this.state.linkList
    fileList.forEach((item, index1) => {
      if (item.response) {
        let url = item.response.key
        url =
          item.response.key.indexOf('http://qiniu-retail.ieou.com/') != -1
            ? item.response.key
            : 'http://qiniu-retail.ieou.com/' + item.response.key

        banner.push({
          img: url,
          link: linkList[index1] ? linkList[index1].url : '',
        })
      }
    })
    banner = JSON.stringify(banner)
    if (file.status === 'done' || file.status === 'removed') {
      fetchSetSmallProgram({ ...this.state.info, banner }).then((res) => {
        if (res.success) {
          message.success('设置成功')
          this.getInfo(false)
        }
      })
    }
    this.setState({ fileList })
  }
  setPrice = (value) => {
    this.setState({
      info: { ...this.state.info, [value]: true },
    })
  }
  priceChange = (e, name) => {
    let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/

    if (reg.test(e)) {
      this.setState({
        info: { ...this.state.info, [name]: e ? e : 0 },
      })
    }
  }
  priceBlur = (value) => {
    setTimeout(() => {
      let banner = []
      let linkList = this.state.linkList
      this.state.fileList.forEach((item, index1) => {
        let url = item.response.key
        url =
          item.response.key.indexOf('http://qiniu-retail.ieou.com/') != -1
            ? item.response.key
            : 'http://qiniu-retail.ieou.com/' + item.response.key

        banner.push({
          img: url,
          link: linkList[index1].url,
        })
      })
      banner = JSON.stringify(banner)

      fetchSetSmallProgram({ ...this.state.info, banner }).then((res) => {
        if (res.success) {
          message.success('操作成功')
          this.setState({
            info: { ...this.state.info, [value]: false },
          })
        }
      })
    }, 0)
  }
  linkChange = (e, index) => {
    let linkList = this.state.linkList
    linkList[index].temp_url = e.target.value
    this.setState({
      linkList,
    })
  }
  linkBlur = (e, index) => {
    let linkList = this.state.linkList
    if (e.target.value !== linkList[index].url) {
      // var reg =
      //   /^https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*$/i;
      // if (!reg.test(e.target.value)) {
      //   message.error("请填入正确的链接");
      // } else {
      linkList[index].url = linkList[index].temp_url

      let banner = []
      this.state.fileList.forEach((item, index1) => {
        let url = item.response.key
        url =
          item.response.key.indexOf('http://qiniu-retail.ieou.com/') != -1
            ? item.response.key
            : 'http://qiniu-retail.ieou.com/' + item.response.key

        banner.push({
          img: url,
          link: linkList[index1].url,
        })
      })
      banner = JSON.stringify(banner)
      fetchSetSmallProgram({ ...this.state.info, banner }).then((res) => {
        if (res.success) {
          message.success('设置成功')
          this.getInfo(false)
        }
      })
      // }
    }
  }
  render() {
    const { previewVisible, previewImage, fileList, token, info, linkList } =
      this.state
    const uploadButton = (
      <div>
        <Icon type='plus' />
        <div className='ant-upload-text'>上传图片</div>
      </div>
    )

    return (
      <div className='container'>
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className='spSet_container'>
          <div className='card'>
            <div className='top'>购买体验页面banner图设置</div>
            <div className='banner_content'>
              <div className='left'>
                {linkList.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{ top: 138 + index * 112 }}
                      className='linkWrap'>
                      <div className='linkTitle'>图片跳转链接</div>
                      <Input
                        onChange={(e) => this.linkChange(e, index)}
                        value={item.temp_url}
                        className='link'
                        onBlur={(e) => this.linkBlur(e, index)}></Input>
                    </div>
                  )
                })}

                <div className='title'>图片设置</div>
                <div className='tips'>图片仅支持jpg，jpeg，png格式 </div>
                <div className='tips'>建议图片大小为750*390px</div>
                <div className='tips'>最多上传3张图片</div>
                <div className='upload'>
                  <Upload
                    action='https://upload.qiniup.com/'
                    data={{
                      token: token,
                      key: new Date().getTime() + '@image',
                    }}
                    listType='picture-card'
                    fileList={fileList}
                    onPreview={this.handlePreview}
                    onRemove={this.handleRemove}
                    onChange={this.handleChange}
                    accept='image/*'>
                    {fileList.length >= 3 ? null : uploadButton}
                  </Upload>

                  <Modal
                    visible={previewVisible}
                    footer={null}
                    onCancel={this.handleCancel}>
                    <img
                      alt='example'
                      style={{ width: '100%' }}
                      src={previewImage}
                    />
                  </Modal>
                </div>
              </div>
              <div className='right'>
                {/* <img className="mobilePhone" src={MobilePhone}></img>
                <Carousel className="banner" autoplay>
                  {info.banner.map((item, index) => {
                    return <img key={index} src={item}></img>;
                  })}
                </Carousel> */}
                <img className='mobilePhone' src={MobilePhone1}></img>
                <Carousel className='banner' autoplay>
                  {info.banner.map((item, index) => {
                    return <img key={index} src={item}></img>
                  })}
                </Carousel>
              </div>
            </div>
          </div>
          <FuncIconSet></FuncIconSet>
          {/* <div className="card">
            <div className="banner_content">
              <div className="left">
                <div className="title">试试如意券价格设置</div>
                <div className="table">
                  <Row className="th">
                    <Col span={12}>划去原价(元）</Col>
                    <Col span={12}>限时特价(元）</Col>
                  </Row>
                  <Row className="td">
                    <Col onClick={() => this.setPrice("setOld")} span={12}>
                      {info.setOld ? (
                        <InputNumber
                          autoFocus
                          min={0}
                          max={9999}
                          style={{ width: "80%" }}
                          onBlur={() => this.priceBlur("setOld")}
                          onChange={(e) => this.priceChange(e, "originalPrice")}
                          value={info.originalPrice}
                        ></InputNumber>
                      ) : (
                        info.originalPrice
                      )}
                    </Col>
                    <Col onClick={() => this.setPrice("setNew")} span={12}>
                      {info.setNew ? (
                        <InputNumber
                          autoFocus
                          min={0}
                          max={9999}
                          style={{ width: "80%" }}
                          onBlur={() => this.priceBlur("setNew")}
                          onChange={(e) => this.priceChange(e, "presentPrice")}
                          value={info.presentPrice}
                        ></InputNumber>
                      ) : (
                        info.presentPrice
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="right">
                <div className="priceCard">
                  <div className="fl">
                    <div className="ex_price">
                      <span className="oldPrice">
                        原价{info.originalPrice}元
                      </span>
                      <span className="newPrice">{info.presentPrice}</span>元
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>*/}
        </div>
      </div>
    )
  }
}
export default SmallProgramSet
